function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, styled } from '@mui/material';
import { GorillaGrid } from '@procom-labs/atoms';
var Header = styled('div')(function(param) {
    var theme = param.theme;
    return _define_property({
        borderBottom: 'none',
        marginBottom: 16
    }, theme.breakpoints.up('sm'), {
        marginBottom: 24
    });
});
export var LegalDocuments = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(GorillaGrid, {
        isGlassMode: true,
        isThemeBackgroundApplied: true,
        sx: {
            borderRadius: '20px',
            pl: {
                xs: 1,
                sm: 2,
                md: 8
            },
            pr: {
                xs: 1,
                sm: 2,
                md: 15
            }
        },
        children: /*#__PURE__*/ _jsx(Header, {
            children: /*#__PURE__*/ _jsx(Box, {
                children: children
            })
        })
    });
};
